module.exports = "pegasus/assets/city3.png";